import { IBrief } from "@shared/lib/types/brief";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface useBriefState {
  briefId: string;
  brief?: IBrief;
  isLoadingBrief: boolean;
}

interface useBriefActions {
  setBrief: (brief: IBrief, id: string) => void;
  setBriefIdOnly: (id: string) => void;
  setIsLoadingBrief: (isLoading: boolean) => void;
  reset: () => void;
}

const getInitialState = (): useBriefState => ({
  briefId: "",
  brief: undefined,
  isLoadingBrief: false,
});

export const useBriefStore = create<useBriefState & useBriefActions>()(
  devtools((set, get) => ({
    ...getInitialState(),
    reset: () => {
      set({ ...getInitialState() });
    },
    setBrief: (brief: IBrief, id: string) => {
      set({ brief, briefId: id });
    },
    setBriefIdOnly: (id: string) => {
      set({ brief: undefined, briefId: id });
    },
    setIsLoadingBrief: (isLoading: boolean) => {
      set({ isLoadingBrief: isLoading });
    },
  }))
);
